module.exports = __webpack_public_path__ + "static/img/CompanyNews-banner.69ae2e36.webp";